import { createSelector } from 'reselect';
import { ORIGINAL_ESTIMATE, STORY_POINTS } from '../../../model/constants';
import type { EstimationEntityState } from '../../reducers/entities/estimation/types';
import type { State } from '../../types';
import { getCards } from '../cards';
import { getEntities } from '../entities';

export const getEstimation = (state: State): EstimationEntityState => getEntities(state).estimation;

// NOTE: Use getEstimationType for estimation related checks. Only use this selector for permission checks regardless of estimation types (almost never happen)
export const isEstimationFeatureEnabled = createSelector(
	getEstimation,
	(estimation: EstimationEntityState) => estimation.isEstimationFeatureEnabled,
);

export const getEstimationType = createSelector(
	getEstimation,
	(estimation: EstimationEntityState) => estimation.estimationType,
);

export const isOriginalEstimateTypeSelector = (state: State) =>
	getEstimationType(state) === ORIGINAL_ESTIMATE;

export const isNumericEstimateTypeSelector = (state: State) =>
	getEstimationType(state) === STORY_POINTS;

export const getEstimationFieldId = createSelector(
	getEstimation,
	(estimation: EstimationEntityState) => estimation.estimationFieldId,
);

export const getEstimationName = createSelector(
	getEstimation,
	(estimation: EstimationEntityState) => estimation.name,
);

export const getIsRemainingTimeTrackingEnabled = createSelector(getCards, (allCards) => {
	const listOfCards = Object.values(allCards);
	if (listOfCards.length <= 0) {
		return false;
	}

	return !!listOfCards[0]?.estimate?.timeRemainingEstimate;
});
